export default __webpack_public_path__ + "static/media/801.6fcf52a3.png";